import SafeTriangle from '@jsclasses/menu/safe-triangle';
import Menu from '@jsclasses/menu/menu';
import { listenDOMEvent } from '@jspartials/dom-api-utils';

import {
  createMenu,
  createSubmenu,
  toggleActiveState,
  addActiveStateItem
} from '@jspartials/menu-utils';

import {
  classes,
  removeClassToElement,
  hasClassElement
} from '@jspartials/class-list-utils';

const selector = {
  menuDesktop: '.js-menu-desktop',
  menuDesktopBackdrop: '.js-menu-desktop__backdrop',
  menuDesktopContent: '.js-menu-desktop__content',
  menuDesktopSubmenuContent: '.js-menu-desktop__submenu-content',
  menuHeaderDesktop: '.js-menu-desktop__header',
  buttonGenderDesktop: '.js-menu-desktop__gender-option',
  desktopMainMenuWrapper: '.js-menu-desktop__main-menu',
  desktopItem: '.js-menu-desktop__item'
};

export default class Desktop extends Menu {
  constructor() {
    super(
      selector.menuDesktop,
      selector.menuDesktopContent,
      selector.desktopMainMenuWrapper,
      selector.buttonGenderDesktop
    );
    this.backdropElement = document.querySelector(selector.menuDesktopBackdrop);
    this.submenuContent = document.querySelector(
      selector.menuDesktopSubmenuContent
    );
    this.items = document.querySelectorAll(selector.desktopItem);
    this.header = document.querySelector(selector.menuHeaderDesktop);
    this.submenuTriangle = new SafeTriangle(
      this.submenuContent,
      this.wrapperCategoriesElement
    );
    this.headerTriangle = new SafeTriangle(this.header, this.header, 'top');

    this.initEvents();
  }

  open() {
    super.open();
  }

  close() {
    super.close();
    this.removeActiveState();
  }

  openSubmenu(button) {
    this.activeSubmenu && this.activeSubmenu.remove();
    this.activeSubmenu = null;
    if (
      button &&
      button.dataset.submenuAssetId &&
      button.dataset.submenuAssetId !== 'null'
    ) {
      createSubmenu(this.submenuContent, button);
    } else {
      removeClassToElement(this.contentElement, classes.is.open);
    }
  }

  closeSubmenu() {
    this.activeSubmenu && this.activeSubmenu.remove();
    this.activeSubmenu = null;
    removeClassToElement(this.contentElement, classes.is.open);
  }

  selectGender(button) {
    if (!hasClassElement(button, classes.is.active)) {
      super.selectGender(button);
      const genderId = button.dataset.gender;
      this.genderButtonElements.forEach((element) => {
        toggleActiveState(button, element);
      });
      createMenu(genderId);

      this.closeSubmenu();
    }
  }

  removeActiveState() {
    const invalidItems = this.wrapperElement.querySelectorAll(
      classes.is.invalid
    );
    const activeItems = this.wrapperElement.querySelectorAll(classes.is.active);

    invalidItems.forEach((item) => {
      removeClassToElement(item, classes.is.invalid);
    });

    activeItems.forEach((item) => {
      removeClassToElement(item, classes.is.active);
    });
  }

  initEvents() {
    if (this.wrapperElement) {
      // Select gender
      this.genderButtonElements.forEach((buttonGenderDesktop) => {
        listenDOMEvent(buttonGenderDesktop, 'mouseenter', (e) => {
          this.selectGender(e.target);
          this.open();
        });
      });

      // Open submenu
      this.items.forEach((menuItem) => {
        addActiveStateItem(
          this.wrapperCategoriesElement,
          menuItem,
          this.openSubmenu.bind(this)
        );
      });

      // Close menu
      this.backdropElement.addEventListener('mouseenter', () => {
        this.close();
        this.genderButtonElements.forEach((button) => {
          removeClassToElement(button, classes.is.active);
          removeClassToElement(button, classes.is.invalid);
        });
      });
    }
  }
}
